import { createUIHeadingMaker } from '../createUIHeadingMaker';
export var makeUIHeading1 = createUIHeadingMaker({
  fontSize: '28px',
  lineHeight: '9u',
  letterSpacing: '-0.5px'
});
export var makeUIHeading2 = createUIHeadingMaker({
  fontSize: '22px',
  lineHeight: '7u',
  letterSpacing: '-0.5px'
});
export var makeUIHeading3 = createUIHeadingMaker({
  fontSize: '18px',
  lineHeight: '6u',
  letterSpacing: '-0.5px'
});
export var makeUIHeading4 = createUIHeadingMaker({
  fontSize: '16px',
  lineHeight: '6u',
  letterSpacing: '-0.2px'
});
export var makeUIHeading5 = createUIHeadingMaker({
  fontSize: '14px',
  lineHeight: '5u',
  letterSpacing: '-0.2px'
});
export var makeUIHeading6 = createUIHeadingMaker({
  fontSize: '12px',
  lineHeight: '4u',
  letterSpacing: '0'
});